import { Component, DestroyRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common'; 
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatInputModule } from '@angular/material/input'; 
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox'; // ➔ 1. importを追加

import { BillingSource, BillingSourceDefaultValue, BillingSourceFormComponent } from './billing-source-form/billing-source-form.component';
import { BillingTerms, BillingTermsDefaultValue, BillingTermsFormComponent } from './billing-terms-form/billing-terms-form.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DebugUtils } from 'src/app/shared/utils/debug-utils';

@Component({
  selector: 'app-billing-info-form',
  templateUrl: './billing-info-form.component.html',
  imports: [
    BillingSourceFormComponent,
    BillingTermsFormComponent,

    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
})
export class BillingInfoFormComponent implements OnInit{
  @Input() billingInfoForm!: FormGroup;

  @ViewChild('billingSourceFormComp') billingSourceFormComponent!: BillingSourceFormComponent;

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {

  }


  public onHasCustomBillingRuleChange(checked: boolean): void {
    console.log("onHasCustomBillingRuleChange", checked);

    if (checked){
      this.billingInfoForm.get('billingTerms')?.disable();
      this.billingInfoForm.get('billingSource')?.disable();
    }
    else{
      this.billingInfoForm.get('billingTerms')?.enable();
      this.billingInfoForm.get('billingSource')?.enable();

      this.billingSourceFormComponent?.onPaymentMethodChange(this.billingInfoForm.get('billingSource.paymentMethod')?.value);
    }

    // console.log("*********** dumping billingInfo form *********");
    // DebugUtils.dumpFormStructure(this.billingInfoForm);
    // console.log("*********** dumping billingInfo form *********");
  }

  getBillingTermsGroup(): FormGroup {
    return this.billingInfoForm.get('billingTerms') as FormGroup;
  }

  getBillingSourceGroup(): FormGroup {
    return this.billingInfoForm.get('billingSource') as FormGroup;
  }

  
  static createBillingInfoGroup(): FormGroup {
    return new FormGroup({
        hasCustomBillingRule: new FormControl(true),
        customBillingRuleNotes: new FormControl(""),
        billingTerms: BillingTermsFormComponent.createBillingTermsGroup(),
        billingSource: BillingSourceFormComponent.createBillingSourceGroup(),
    })
  }
}

export interface BillingInfo {
  hasCustomBillingRule: boolean,
  customBillingRuleNotes: string,
  billingTerms: BillingTerms,
  billingSource: BillingSource,
}
export const BillingInfoDefaultValue = {
  hasCustomBillingRule: true,
  customBillingRuleNotes: "",
  billingTerms: BillingTermsDefaultValue,
  billingSource: BillingSourceDefaultValue,
}